import { Outlet, useLocation } from 'react-router-dom';
import { ChevronUp } from 'lucide-react';
import { useEffect, useState } from 'react';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import ScrollToTop from './ScrollToTop';
import CookieBanner from './CookieBanner';

const SiteLayout = () => {
  const [showScroll, setShowScroll] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setShowScroll(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Protection images : bloque clic droit, drag et raccourcis de sauvegarde
  useEffect(() => {
    const blockOnImage = (e: Event) => {
      const target = e.target as HTMLElement;
      if (target && (target.tagName === 'IMG' || target.closest?.('picture'))) {
        e.preventDefault();
      }
    };
    const blockKeys = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && ['s', 'S', 'u', 'U'].includes(e.key)) {
        e.preventDefault();
      }
    };
    document.addEventListener('contextmenu', blockOnImage);
    document.addEventListener('dragstart', blockOnImage);
    document.addEventListener('keydown', blockKeys);
    return () => {
      document.removeEventListener('contextmenu', blockOnImage);
      document.removeEventListener('dragstart', blockOnImage);
      document.removeEventListener('keydown', blockKeys);
    };
  }, []);

  return (
    <div className="site-public min-h-screen bg-background flex flex-col">
      <ScrollToTop />
      <SiteHeader />
      <main className={`flex-1 ${isHome ? '' : 'pt-[124px]'}`}>
        <Outlet />
      </main>
      <SiteFooter />
      <CookieBanner />

      {showScroll && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-20 right-6 z-50 w-10 h-10 rounded-lg bg-primary text-primary-foreground flex items-center justify-center hover:bg-primary/90 transition-colors shadow-lg"
          aria-label="Retour en haut"
        >
          <ChevronUp size={18} />
        </button>
      )}
    </div>
  );
};

export default SiteLayout;
